/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-13 13:44:18
 * @LastEditors: linxi
 * @LastEditTime: 2025-05-23 15:27:37
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Modal, notification, Pagination, Space } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import styles from './followUpPage.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import { Retail } from '../../models/retail'
import { Query } from './query'
import { Columns } from './columns'
import {
  cancelFollowUp,
  detailFollowUpListPage,
  FollowUpType,
  getChainFollowUpListPage,
  getFollowUpListPage,
  selectAddVisibleData,
  setAddVisible,
  getFollowUpExport,
} from './followUpPageSlice'
import { AddFollowUpModal } from './addFollowUp'
import { setId } from '../putstorage/putstorageSlice'
import { DetailModal } from './detailModal'
import { useLocation } from 'react-router-dom'
import { DateRangeType, getDateRange } from '../../compnents/form/DateSelect'
import { SJQXChecks } from "../../models/dataPersion";
import { getCheckPermissionAsync } from "../FunctionSetting/dataPermission/dataPermissionSlice";

export const FollowUpPage = (props: {
  state: any
  patientId?: string
  tenantId?: string
  toothPatient?: boolean
  status?: number //口腔专业版1 否则0
  chainFlag?: boolean //中医连锁患者详情的随访信息
  onLeftCount?: (obj: any) => void
  SYCKHRSJHData?: boolean
  SYCKHZSFZHData?: boolean
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const isAddVisibel: any = useSelector(selectAddVisibleData)

  const location = useLocation<any>()

  const [tableLoading, setTableLoading] = useState(false) //表格 loading

  const [exportLoading, setExportLoading] = useState(false) //导出 loading

  const [followUpTypeList, setFollowUpTypeList] = useState<any>() //随访类型数据

  const [detailModalVisible, setDetailModalVisible] = useState(false) //详情 modal

  const [detailModalTitle, setDetailModalTitle] = useState('') //详情 modal

  const [detailDataInfo, setDetailDataInfo] = useState<any>() //详情 modal

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [id, setId] = useState<any>()

  const [editMode, setEditMode] = useState(false)

  const [bnindType, setBindType] = useState<any>()

  const [bnindId, setBindId] = useState<any>()

  const [params, setParams] = useState<any>({
    current: 0,
    size: 10,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [head, tail] = getDateRange(DateRangeType.ThisWeek)

  const isCompletedFollowUp = params?.state == '1'

  const [CKSJHQXData, setCKHRSJHData] = useState(true) // 随访查看患者手机号权限

  const [CKHZSFZHData, setCKHZSFZHData] = useState(true) // 随访查看患者身份证号权限

  useEffect(() => {
    //如果有 patientId就是患者详情页面的随访信息
    // status== 1 口腔版首页随访
    if (props?.SYCKHRSJHData != null) {
      setCKHRSJHData(props?.SYCKHRSJHData)
    } else {
      const itemCode = props?.status == 1 ? SJQXChecks.SYCKHRSJH : props.patientId ? SJQXChecks.HZGLCKHZSJH : SJQXChecks.SFCKHRSJH
      dispatch(getCheckPermissionAsync({ itemCode: itemCode }))
        .then(unwrapResult)
        .then((res: any) => {
          setCKHRSJHData(res)
        })
    }
    if (props?.SYCKHZSFZHData != null) {
      setCKHRSJHData(props?.SYCKHZSFZHData)
    } else {
      const itemCode = props?.status == 1 ? SJQXChecks.SYCKHHZSFZH : props.patientId ? SJQXChecks.HZGLCKHZSFZH : SJQXChecks.SFCKHZSFZH
      dispatch(getCheckPermissionAsync({ itemCode: itemCode }))
        .then(unwrapResult)
        .then((res: any) => {
          setCKHZSFZHData(res)
        })
    }

  }, [])

  useEffect(() => {
    if (props.state == '3') return
    //数据缓存
    setParams({ ...params, state: props.state })
  }, [props.state])

  useEffect(() => {
    dispatch(setAddVisible(isModalVisible))
  }, [isModalVisible])

  const getType = () => {
    dispatch(FollowUpType())
      .then(unwrapResult)
      .then((res) => {
        setFollowUpTypeList(res)
      })
  }


  const getPage = () => {
    setTableLoading(true)
    if (props.state == '0') {
      //获取随访表格列表
    }
    const getFollowUpList = props?.chainFlag ? getChainFollowUpListPage : getFollowUpListPage
    dispatch(
      getFollowUpList({
        ...params,
        startTime: params?._dateRange == 7 ? undefined : (params?.startTime || head),
        endTime: params?._dateRange == 7 ? undefined : (params?.endTime || tail),
        patientId: props.patientId,
        tenantId: props.chainFlag ? props.tenantId : undefined,
      })
    )
      .then(unwrapResult)
      .then((res) => {
        const data = {
          total: res.total,
          items: res.records,
        }
        setPage(data)
        setTableLoading(false)
      })
      .catch(() => {
        setTableLoading(false)
      })
  }

  const handleExport = () => {
    setExportLoading(true)
    dispatch(
      getFollowUpExport({
        ...params,
        startTime: params?._dateRange == 7 ? undefined : (params?.startTime || head),
        endTime: params?._dateRange == 7 ? undefined : (params?.endTime || tail),
        patientId: props.patientId,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '随访记录.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        notification.error({
          message: '导出失败',
          duration: 3,
        })
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  useEffect(() => {
    getType()
  }, [])

  useEffect(() => {
    if (!params.current) return
    sessionStorage.setItem(
      location.pathname + "_suifang",
      JSON.stringify({
        ...params,
        state: props.state == '3' ? 0 : props.state,
      })
    )
    getPage()
  }, [params])

  useEffect(() => {
    setParams({
      ...params,
      patientId: props.patientId
    })
  }, [props.patientId])


  const toothPatientFilter = props.toothPatient
    ? ['name', 'sex', 'age', 'phone']
    : []

  return (
    <div
      className={styles.wrap}
      style={{
        height: '100%',
        padding: '20px 15px',
      }}
    >
      {!props.patientId && props.status != 1 && (
        <div className={styles.addFollowUp}>
          <Space>
            <div style={{ color: '#333333' }}>
              （最多支持导出10000条数据，更多请联系客服）
            </div>
            <Button
              type='primary'
              loading={exportLoading}
              onClick={handleExport}
            >
              导出
            </Button>
            <Button
              type='primary'
              onClick={() => {
                setIsModalVisible(true)
              }}
            >
              新增随访
            </Button>
          </Space>
        </div>
      )}
      <Query
        chainFlag={props.chainFlag}
        loading={tableLoading}
        status={props.state}
        type={props.status || 0}
        patientId={props.patientId}
        followUpTypeList={followUpTypeList}
        toothPatient={props.toothPatient}
        onValueChange={(v) => {
          setParams({
            ...params,
            ...v,
            state: v.stateV ? v.stateV : v.state,
            current: 1,
          })
          props.onLeftCount &&
            props.onLeftCount({
              nameV: v.name,
              startTimeV: v.startTime ? v.startTime : v.timeHead,
              endTimeV: v.endTime ? v.endTime : v.timeTail,
              stateV: v.stateV,
              visitFlagV: v.flag,
              visitUserIdV: v.userId,
            })
        }}
      />
      <EditableList
        bordered={props.status == 1 ? true : false}
        loading={tableLoading}
        style={{ flex: 1 }}
        className={styles.table}
        sticky={location.pathname == '/toothHome'}
        rowKey={(v, i) => `${i}`}
        page={{
          current: params.current,
          size: params.size,
          total: page.total,
          items: page.items,
        }}
        columns={Columns(
          (id, text, item) => {
            if (text == 'detail') {
              //详情
              dispatch(detailFollowUpListPage({ id }))
                .then(unwrapResult)
                .then((res) => {
                  setDetailDataInfo(res)
                  setDetailModalVisible(true)
                  setDetailModalTitle('随访详情')
                })
            } else if (text == 'edit') {
              //执行
              setId(id)
              setBindType(item?.bindType)
              setBindId(item?.bindId)
              setEditMode(isCompletedFollowUp)
              setIsModalVisible(true)
            } else if (text == 'cancel') {
              //取消
              dispatch(cancelFollowUp({ id }))
                .then(unwrapResult)
                .then((res) => {
                  notification.success({ message: '操作成功' })
                  getPage()
                })
            }
          },
          10 * (params.current - 1),
          params?.state,
          props.patientId,
          CKSJHQXData,
          CKHZSFZHData,
          props?.chainFlag
        ).filter((v: any) => !toothPatientFilter.includes(v.dataIndex))}
        onChangePage={(current, size) =>
          setParams({ ...params, current, size })
        }
      />
      {props.toothPatient && (
        <div>
          <Button
            type='primary'
            size='middle'
            onClick={() => setIsModalVisible(true)}
            style={{
              position: 'absolute',
              left: 15,
              bottom: 0,
            }}
          >
            新增随访
          </Button>
        </div>
      )}
      <DetailModal
        patientId={props.patientId}
        SJQX={CKSJHQXData}
        title={detailModalTitle}
        visible={detailModalVisible}
        detailDataInfo={detailDataInfo}
        onOk={() => {
          setDetailModalVisible(false)
        }}
        onCancel={() => {
          setDetailModalVisible(false)
        }}
      />
      <AddFollowUpModal
        CKSJHQXData={CKSJHQXData}
        CKHZSFZHData={CKHZSFZHData}
        status={props.status} //区分口腔专业 1还是正常 0
        treatmentTag={false} //非病历那边点开不需要查询条件以及治疗计划
        bindId={bnindId}
        tablePatientId={props.toothPatient ? props.patientId : undefined}
        bindType={bnindType}
        id={id}
        editMode={editMode}
        isModalVisible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false)
          getPage()
          setId('')
          setBindId('')
          setBindType('')
          setEditMode(false)
          getType()
        }}
        onOk={() => {
          setIsModalVisible(false)
          getPage()
          setId('')
          setBindId('')
          setBindType('')
          setEditMode(false)
          getType()
        }}
      ></AddFollowUpModal>
    </div>
  )
}
